import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Map } from 'immutable';

import { BibliographicResource } from '®shared/bibliographic-resource';
import { Loadable, Saveable } from '®shared/data';

export const STATE_FEATURE_RESOURCE = 'resource';

export interface ResourceState {
  resourceById: Map<string, Loadable<BibliographicResource>>;
  saveableResource: { data?: BibliographicResource } & Saveable;
}

export const INITIAL_RESOURCE_STATE: ResourceState = {
  resourceById: Map<string, Loadable<BibliographicResource>>(),
  saveableResource: null,
};

export function getInitialResourceState(): ResourceState {
  return INITIAL_RESOURCE_STATE;
}

export const selectResourceState = createFeatureSelector<ResourceState>(
  STATE_FEATURE_RESOURCE,
);

export const selectResourceById = createSelector(
  selectResourceState,
  state => state.resourceById,
);

export const selectResourceWithId = (resourceId: string) =>
  createSelector(selectResourceById, state => state.get(resourceId, null));

export const selectSaveableResource = createSelector(
  selectResourceState,
  state => state.saveableResource,
);
